import React from 'react';
import { Link } from 'react-router-dom';
import { FaCheckCircle, FaArrowRight, FaTrophy, FaUsers, FaMedal, FaHeart } from 'react-icons/fa';
import './About.css';

const AdvancedCompetitiveTrainingProgram = () => {

    return (
        <div className="about-page">
            {/* Main About Section */}
            <section className="about-main section">
                <div className="container">
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>Advanced & Competitive Training Program</h2>
                            <p>
                                The Advanced & Competitive Training Program at Net Nest Badminton Sports Club is specially designed for experienced players who aim to compete at district, state, national, and higher levels. This program focuses on refining high-level skills, match strategies, physical conditioning, and mental toughness required for elite badminton performance.
                            </p>
                            <h2>Program Overview</h2>
                            <p>
                                This program provides intensive, performance-driven training for players who have mastered basic and intermediate skills. Training sessions are structured to simulate real match conditions, helping players develop consistency, precision, and confidence in competitive environments.
                            </p>
                        </div>
                        <div className="about-main-images">
                            <img src="img/Advanced & Competitive Training Program.jpg" alt="Badminton Court" className="main-image" />
                        </div>
                    </div>
                    <div className="about-main-grid">
                        <div className="about-main-content">
                            <h2>High-Level Technical Training</h2>
                            <p>
                                Powerful and controlled smash variations
                                <br></br>
                                Deceptive drop shots and net play
                                <br></br>
                                Advanced defensive techniques and counter-attacks
                                <br></br>
                                Precision shot placement and rally control
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Advanced Footwork & Speed Development</h2>
                            <p>
                                Multi-directional court movement
                                <br></br>
                                Explosive starts and quick recovery steps
                                <br></br>
                                Advanced agility and reaction drills
                                <br></br>
                                Balance and coordination under high pressure
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Tactical & Match Strategy Development</h2>
                            <p>
                                Advanced singles and doubles tactics
                                <br></br>
                                Opponent analysis and game planning
                                <br></br>
                                Shot selection based on match situations
                                <br></br>
                                Score-based strategy and momentum control
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Intensive Fitness & Conditioning</h2>
                            <p>
                                Strength and explosive power
                                <br></br>
                                Endurance and stamina for long matches
                                <br></br>
                                Core stability and injury prevention
                                <br></br>
                                Recovery and flexibility techniques
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Mental Conditioning & Competitive Mindset</h2>
                            <p>
                                Match focus and concentration
                                <br></br>
                                Pressure handling and emotional control
                                <br></br>
                                Confidence building and resilience
                                <br></br>
                                Goal setting and performance tracking
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Match Practice & Tournament Exposure</h2>
                            <p>
                                Competitive match simulations
                                <br></br>
                                Practice matches with top-level players
                                <br></br>
                                Internal ranking matches
                                <br></br>
                                Preparation for external tournaments
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Performance Evaluation & Progress Tracking</h2>
                            <p>
                                Technical improvement and consistency
                                <br></br>
                                Physical performance and fitness levels
                                <br></br>
                                Match results and tactical growth
                            </p>
                        </div>
                        <div className="about-main-images">
                            <h2>Ideal for Competitive Players</h2>
                            <p>
                                District and state-level players
                                <br></br>
                                National-level aspirants
                                <br></br>
                                Advanced academy trainees
                                <br></br>
                                Players preparing for professional tournaments
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default AdvancedCompetitiveTrainingProgram;